import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Editor } from "../controls/Editor";
import { useDispatch } from "react-redux";
import { devActions } from "../../../redux/actions";
import { emptyObject } from "../../../redux/utils";
import { PanelSpinner } from "./PanelSpinner";
import { VisualHtmlEditor } from "./VisualHtmlEditor/";

export const FileEditorTemplate = ({tab, index}) => {

  const dispath = useDispatch();
  const [ loaded, setLoaded ] = useState(false);
  const [ mode, setMode ] = useState("editor")
  const formik = useFormik({
    initialValues: tab?.data?.data?.value || emptyObject,
    onSubmit: (data) => {},
  })
  
  useEffect(() => {
    console.log("refresh values", tab)
    if(!!tab?.data?.data?.value){
      formik.setValues(tab?.data?.data?.value);
      setLoaded(true);
    }else if(!!tab?.data?.metadata?.item){
      formik.setValues(tab?.data?.metadata?.item);
      setLoaded(true);      
    }
  }, [tab?.data?.data?.value, tab?.data?.metadata?.item])

  const handleCodeChange = (code) => {
    console.log("formikValues", formik.values)
    if(code !== formik.values.template){
      formik.setFieldValue("template", code);
      dispath(devActions.setChangedTab(index, true));
      dispath(devActions.updateTabTemplate(index, code));
    }
  }

  const handleChangeMode = () => {
    setMode(mode => mode === "editor" ? "visual" : "editor");
  }
  
  const isLive = tab.data.name.startsWith("Live");

  return (
    <>
      {loaded && 
        <div
          style={{height: "100%", position: "relative"}}
        >
          {!isLive &&
            <div onClick={handleChangeMode}>{mode === "editor" ? "visual" : "editor"}</div>
          }
          {mode === "editor" && 
            <Editor
              mode={tab.data.name.startsWith("Live") ? "jsx" : "html"}
              autoFocus={true}
              value={formik.values.template}
              onValueChange={handleCodeChange}
              fontSize={16}
              showToolbar={false}
              maxHeight = "100%"
              editorStyle={{height: "100%", backgroundColor: "#272822", position: "relative"}}
            />
          }
          {mode === "visual" &&         
            <VisualHtmlEditor value={formik.values.template} onValueChange={handleCodeChange}/>
          }
        </div>
      }
      {!loaded && 
        <PanelSpinner />
      }
    </>
  )

}